import { useMutation, useQueryClient } from 'react-query';
import { httpClient } from 'src/utils/HttpClients';
import type { TPostBookingPayload } from 'src/types/booking';
import get from 'lodash/get';
import { useAppState } from 'src/context';
import type { TSubLocation } from 'src/types';
import { DATE_FORMAT } from 'src/constants';

export const useAddBooking = () => {
    const queryClient = useQueryClient();
    const {
        values: { range, location },
    } = useAppState();

    // Getting sub locations list
    const sData = queryClient.getQueryData(['sub-locations', location]);
    const params = {
        sublocation_id: get(sData, 'data', []).map((subLocation: TSubLocation) => subLocation.id),
        start_date: range.from.toFormat(DATE_FORMAT),
        end_date: range.to.toFormat(DATE_FORMAT),
    };

    const queryFn = async (payload: TPostBookingPayload) => {
        const { data } = await httpClient.post('/booking', payload);
        return data;
    };

    const onSuccess = async () => {
        await Promise.all([
            queryClient.invalidateQueries(['bookings', params]),
            queryClient.invalidateQueries(['policy-compliance'], { exact: false }),
        ]);
    };

    return useMutation(queryFn, { onSuccess });
};
